import { Router } from "preact-router";
import {
  CONFIRM_EDIT_PATH,
  CONFIRM_PATH,
  DISPUTE_PATH,
  EDIT_PATH,
  EDIT_PENDING_PATH,
  ERROR_PATH,
  FORM_PATH,
  IMPRINT_PATH,
  PENDING_PATH,
  PRIVACY_PATH,
  REVOKE_PATH,
  THANKYOU_PATH,
} from "./routes";
import { ConfirmEditScreen } from "./screens/confirmEditScreen";
import { ConfirmScreen } from "./screens/confirmScreen";
import { DisputeEvidenceScreen } from "./screens/disputeEvidenceScreen";
import { EditFormScreen } from "./screens/editFormScreen";
import { EditPendingScreen } from "./screens/editPendingScreen";
import { ErrorScreen } from "./screens/errorScreen";
import { LegalsScreen } from "./screens/legalsScreen";
import { PendingScreen } from "./screens/pendingScreen";
import { ReviewFormScreen } from "./screens/reviewFormScreen";
import { RevokeScreen } from "./screens/revokeScreen";
import { ThankYouScreen } from "./screens/thankYouScreen";

export function App() {
  return (
    <Router>
      <EditPendingScreen path={EDIT_PENDING_PATH} />
      <EditFormScreen path={EDIT_PATH} />
      <ReviewFormScreen path={FORM_PATH} />
      <PendingScreen path={PENDING_PATH} />
      <ConfirmScreen path={CONFIRM_PATH} />
      <ConfirmEditScreen path={CONFIRM_EDIT_PATH} />
      <RevokeScreen path={REVOKE_PATH} />
      <DisputeEvidenceScreen path={DISPUTE_PATH} />
      <ThankYouScreen path={THANKYOU_PATH} />
      <LegalsScreen path={PRIVACY_PATH} kind="privacy" />
      <LegalsScreen path={IMPRINT_PATH} kind="imprint" />
      <ErrorScreen path={ERROR_PATH} />
      <ErrorScreen default />
    </Router>
  );
}
